import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { MenuItem, Select } from "@mui/material";
import type { SelectChangeEvent } from "@mui/material";
import type { GridRenderEditCellParams } from "@mui/x-data-grid";
// @ts-expect-error: ignoring as it is existing js file
import { updateApplication } from "../../store/slices/applicationFormSlice";
import { openSnackbar } from "../../store/slices/snackbarSlice";
import { APPLICATION_STATUS, ERRORS_MESSAGE } from "../../constants";

interface StatusCellProps {
  params: GridRenderEditCellParams<string, { id: string; status: string }>;
  applicationId: string;
  updateApplicationStatus: (application: { _id: string; status: string }) => void;
}

export default function StatusCell({ params, updateApplicationStatus, applicationId }: StatusCellProps) {
  const dispatch = useDispatch();
  const [value, setValue] = useState(params.row.status);

  useEffect(() => {
    setValue(params.row.status);
  }, [params.row.status]);

  const handleStatusUpdate = async (event: SelectChangeEvent<string>) => {
    const status = event.target.value;
    try {
      await dispatch(updateApplication({ applicationId, _id: params.row.id, status })).unwrap();
      setValue(status);
      updateApplicationStatus({ _id: params.row.id, status });
    } catch (error) {
      const message =
        typeof error === "object" &&
        error !== null &&
        "status_message" in error &&
        typeof error.status_message === "string"
          ? error.status_message
          : undefined;
      dispatch(openSnackbar({ message: message || ERRORS_MESSAGE.fetchErrorMsg, intent: "danger" }));
    }
  };

  return (
    <Select labelId="demo-simple-select-label" id="demo-simple-select" value={value} onChange={handleStatusUpdate}>
      {APPLICATION_STATUS?.map((status) => (
        <MenuItem value={status.value} key={status.value}>
          {status.label}
        </MenuItem>
      ))}
    </Select>
  );
}
